import { render, staticRenderFns } from "./checkListCategoryList.vue?vue&type=template&id=1c13210a&scoped=true&"
import script from "./checkListCategoryList.vue?vue&type=script&lang=js&"
export * from "./checkListCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13210a",
  null
  
)

export default component.exports